import configStore from '../config-store';
import ScriptInjector from './script-injector';

export default new ScriptInjector(configStore, document);
